export const AttachmentFields = (vm) => {
  return [
    { label: vm.$t('fleetTask.downloadPhoto.fields.fileName'), key: 'fileName' },
    { label: 'Status', key: 'status' },
    { label: vm.$t('global.field.action'), key: 'action' },
  ]
}
